import { BID_PREFIX } from '../utils/consts.mjs';
import { getDefaultCookieAttributes, createCookieString, filterCookiesByPrefix, deleteCookie, getCookie } from '../utils/cookies/cookie-utils.mjs';
import { getBrowserIdFromCdp } from '../utils/get-browser-id-from-cdp.mjs';

/**
 * Gets the value for a given cookie name
 * @param cookieName - The cookie name to be found
 * @returns - The value of the cookie if it exists or empty string
 */
function getCookieValue(cookieName) {
    var _a;
    const cookie = getCookie(document.cookie, cookieName);
    return (_a = cookie === null || cookie === void 0 ? void 0 : cookie.value) !== null && _a !== void 0 ? _a : '';
}
/**
 * Creates and adds the cookie to the document
 * @param targetURL - The targetURL from global settings
 * @param clientKey - The clientKey from global settings
 * @param settings - The ICookieSettings settings object
 * @returns - browserId or undefined on error
 */
async function createCookie(targetURL, clientKey, settings) {
    const browserId = await getBrowserIdFromCdp(targetURL, clientKey);
    const attributes = getDefaultCookieAttributes(settings.cookieExpiryDays, settings.cookieDomain);
    document.cookie = createCookieString(settings.cookieName, browserId, attributes);
    return browserId;
}
/**
 * Replaces the obsolete cookies starting with BID_ with new ones starting with bid_ keeping the same value.
 * @param cookieStr - The cookie string containing every cookie
 * @param settings - The ICookieSettings settings object
 */
function replaceObsoleteCookieNamePrefixes(settings) {
    const obsoleteCookies = filterCookiesByPrefix(document.cookie, 'BID_');
    obsoleteCookies.forEach((obsoleteCookie) => {
        deleteCookie(obsoleteCookie.name);
        const newCookie = {
            name: obsoleteCookie.name.replace('BID_', BID_PREFIX),
            value: obsoleteCookie.value,
        };
        const cookieAttributes = getDefaultCookieAttributes(settings.cookieExpiryDays, settings.cookieDomain);
        document.cookie = createCookieString(newCookie.name, newCookie.value, cookieAttributes);
    });
}

export { createCookie, getCookieValue, replaceObsoleteCookieNamePrefixes };
